import Image from "next/image";
import Link from "next/link";

import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

export const Labelize = () => {
  const i18n = useI18n();

  return (
    <div className="flex overflow-hidden relative flex-col-reverse gap-0 pt-12 mb-8 bg-lime-green rounded-xl lg:flex-row lg:gap-10 lg:pr-10 lg:mb-[60px]">
      <div className="hidden justify-end items-center ml-5 w-2/5 lg:flex">
        <Image
          width={350}
          height={480}
          src="/images/seo/comment-ca-marche/labelize-desktop.webp"
          alt="Responsible digital label - desktop"
        />
      </div>
      <div className="block px-5 mx-auto translate-y-3 lg:hidden">
        <Image
          width={320}
          height={255}
          src="/images/seo/comment-ca-marche/labelize-mobile.webp"
          alt="Responsible digital label - mobile"
        />
      </div>

      <section className="flex flex-col flex-1 gap-10 items-center p-6 pb-9 text-center lg:items-start lg:text-left">
        <h2 className="p-2.5 w-fit text-3xl text-lime-green bg-white">
          {i18n.t("howItWorks.labelize.title", {}, { html: true })}
        </h2>
        <p className="text-lg text-white">
          {i18n.t("howItWorks.labelize.description", {}, { html: true })}
        </p>
        <Link href="/smartphone">
          <a>
            <Button className="-mt-6 w-fit">
              {i18n.t("howItWorks.labelize.button")}
            </Button>
          </a>
        </Link>
      </section>
    </div>
  );
};
